import React from 'react'
import { Box, Container, Toolbar, Button, Typography } from '@mui/material'
import { Outlet } from 'react-router-dom'
import SettingsIcon from '@mui/icons-material/Settings'
import { useTranslation } from 'react-i18next'

//Boundaries
import GeneralBoundary from 'components/Boundary/GeneralBoundary'

interface Props {
  TOP_MARGIN_MD: string
  TOP_MARGIN_SM: string
}

const DashboardMain = (props: Props) => {
  const { TOP_MARGIN_SM, TOP_MARGIN_MD } = props
  const { t } = useTranslation()
  return (
    <>
      <Box
        component="main"
        sx={{
          position: 'relative',
          flexGrow: 1,
          px: { xs: 0, lg: 3 },
        }}
      >
        <Toolbar
          sx={{
            minHeight: { xs: TOP_MARGIN_SM, sm: TOP_MARGIN_MD, lg: '113px' },
          }}
        />
        <Container maxWidth="xl" sx={{ px: { xs: 0 } }}>
          <GeneralBoundary>
            <Outlet />
          </GeneralBoundary>
        </Container>
        <Toolbar />

        {/* <Box
          component="footer"
          sx={{
            position: 'absolute',
            bottom: 0,
            py: 3,
          }}
        >
          <Container maxWidth="xl">
            Copyright © {new Date().getFullYear()} Spourgiti. All rights
            reserved.
          </Container>
        </Box> */}
      </Box>
      <Button
        startIcon={<SettingsIcon />}
        onClick={() => {
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          klaro.show()
        }}
        sx={{
          '&:hover': {
            backgroundColor: 'black',
          },
          bgcolor: 'black',
          width: '126px',
          height: '30px',
          position: 'fixed',
          justifySelf: 'right',
          bottom: '0px',
          right: '0px',
          opacity: '0.7',
          borderRadius: '1%',
          zIndex: 700,
        }}
      >
        <Typography
          align="center"
          color="primary"
          sx={{
            '&:hover': {
              color: 'primary',
              opacity: '1',
            },
            opacity: '0.7',
          }}
        >
          {t(`layouts.privacy`)}
        </Typography>
      </Button>
    </>
  )
}

export default React.memo(DashboardMain)
